import { render, staticRenderFns } from "./WechatPage.vue?vue&type=template&id=5545d142&scoped=true"
import script from "./WechatPage.vue?vue&type=script&lang=js"
export * from "./WechatPage.vue?vue&type=script&lang=js"
import style0 from "./WechatPage.vue?vue&type=style&index=0&id=5545d142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5545d142",
  null
  
)

export default component.exports